import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const Person3Icon: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        style={customStyle}
        fill="none"
        viewBox="0 0 28 18"
      >
        <path
          fill="currentColor"
          d="M14 8.742c2.127 0 3.85-1.872 3.85-4.175C17.85 2.3 16.136.49 14 .49c-2.11 0-3.85 1.837-3.85 4.096.01 2.294 1.723 4.157 3.85 4.157m-10.195.202c1.854 0 3.348-1.643 3.348-3.673 0-1.978-1.494-3.578-3.348-3.578C1.968 1.693.447 3.32.456 5.28c0 2.03 1.503 3.665 3.349 3.665m20.39 0c1.837 0 3.34-1.634 3.349-3.665.009-1.96-1.512-3.586-3.349-3.586-1.854 0-3.357 1.6-3.357 3.578 0 2.03 1.503 3.673 3.357 3.673M14 7.204c-1.213 0-2.241-1.142-2.241-2.628 0-1.432 1.02-2.549 2.241-2.549 1.23 0 2.241 1.099 2.241 2.54 0 1.477-1.02 2.637-2.241 2.637m-10.195.22c-.993 0-1.837-.95-1.837-2.145 0-1.142.835-2.074 1.837-2.074 1.02 0 1.845.914 1.845 2.066 0 1.204-.843 2.153-1.845 2.153m20.39 0c-1.01 0-1.845-.95-1.845-2.153 0-1.152.826-2.066 1.845-2.066.994 0 1.837.932 1.837 2.074 0 1.196-.843 2.145-1.837 2.145m-25.224 9.598H5.8c-.484-.282-.809-.923-.747-1.503h-6.161c-.167 0-.238-.08-.238-.229 0-2.013 2.356-3.929 5.142-3.929.984 0 1.969.246 2.725.668.298-.43.667-.8 1.15-1.116-1.115-.686-2.504-1.055-3.875-1.055-3.718 0-6.724 2.655-6.724 5.573 0 1.054.633 1.59 1.899 1.59m30.058 0c1.266 0 1.899-.537 1.899-1.591 0-2.918-3.015-5.573-6.733-5.573-1.362 0-2.76.37-3.867 1.055.483.316.853.686 1.143 1.116.756-.422 1.749-.668 2.724-.668 2.786 0 5.15 1.916 5.15 3.929 0 .15-.07.229-.237.229h-6.17c.062.58-.254 1.221-.738 1.502zm-20.505 0h10.952c1.52 0 2.25-.484 2.25-1.521 0-2.417-3.015-5.634-7.726-5.634-4.71 0-7.734 3.217-7.734 5.634 0 1.037.738 1.52 2.258 1.52m-.28-1.539c-.203 0-.282-.07-.282-.228 0-1.345 2.17-3.85 6.038-3.85 3.867 0 6.038 2.505 6.038 3.85 0 .158-.079.228-.29.228z"
        ></path>
      </svg>
    </div>
  );
};

export default Person3Icon;
